import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const AiReport = ({ eventId, text, onDone, canEdit, stale }) => {
  const [busy, setBusy] = useState(false);
  const [live, setLive] = useState("");

  const run = async () => {
    setBusy(true);
    setLive("");
    let acc = "";
    try {
      const res = await fetch(`${API}/events/${eventId}/report`, { method: "POST", credentials: "include" });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.detail || "No se pudo generar el informe");
      }
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          if (!p.startsWith("data: ")) continue;
          const d = JSON.parse(p.slice(6));
          if (d.error) throw new Error(d.error);
          if (d.t) { acc += d.t; setLive(acc); }
        }
      }
      onDone(acc);
      toast.success("Orden de servicio redactada");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
      setLive("");
    }
  };

  const shown = busy ? live : text;
  return (
    <div data-testid="ai-report-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="text-sm text-slate-500 max-w-xl">La IA redacta la orden de servicio a partir de los cálculos del plan: cronología, cortes, desvíos, relevos de personal y señalización.</p>
        {canEdit && (
          <Button onClick={run} disabled={busy || stale} data-testid="generate-ai-report-button" className="bg-amber-500 hover:bg-amber-400 text-slate-950">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />}
            {text ? "Volver a redactar" : "Redactar orden de servicio"}
          </Button>
        )}
      </div>
      {stale && <div className="text-xs text-amber-700 mb-3">Regenere el plan antes de redactar el informe.</div>}
      {shown ? (
        <div className="report-md bg-slate-50 border border-slate-200 rounded-xl p-6" data-testid="ai-report-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{shown}</ReactMarkdown>
        </div>
      ) : (
        <div className="text-sm text-slate-500 border border-dashed border-slate-200 rounded-xl p-10 text-center" data-testid="ai-report-empty">Aún no se ha redactado el informe.</div>
      )}
    </div>
  );
};
